export default __webpack_public_path__ + "static/media/2022_November_Landschaft.8c6ea9cd.webp";